import { Input, Button, Icons, Text } from '@oc-labs/wt-storybook';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useEffect, useState, useMemo } from 'react';
import useAuth from '../../../../hooks/useAuth';

export default function AuthPasswordResetView() {
  const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const navigate = useNavigate();
  const { client } = useAuth();

  useEffect(() => {
    if(!queryParams.has('token')) {
      navigate(`/auth/login${window.location.search}`);
    }
  }, [queryParams]);

  const handleResetPassword = async () => {
    if (password !== confirmPassword) return toast.error(t('passwords_mismatch'))
    toast.promise(
      client.resetPassword({
        token: queryParams.get('token'),
        newPassword: password,
      }),
      {
        loading: 'Resetting password...',
        success: 'Password reset successful.',
        error: 'Error resetting password.',
      }
    ).then(() => {
      navigate(`/auth/login${window.location.search}`);
    });
  };

  return (<div className='p-4 flex flex-col'>
    <div className="flex items-center space-x-2 mb-8 mt-4">
      <Link className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center" to={`/auth/login${window.location.search}`}>
        <Icons name="chevron_left" size={16} />
      </Link>

      <div className="text-lg font-semibold">
        <Text>Reset Password</Text>
      </div>
    </div>

    <div className="mb-8">
      <Text>
        Reset your password by entering a new one below.
      </Text>
    </div>


    <div className="mb-4">
      <Input label={<Text>New Password</Text>} type='password' placeholder="Enter your new password" className="mb-4" value={password} onChange={(e) => setPassword(e.target.value)} />
    </div>

    <div className="mb-6">
      <Input label={<Text>Repeat Password</Text>} type='password' placeholder="Repeat your new password" className="mb-6" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
    </div>

    <div className="mt-auto mb-4">
      <Button type="primary" size="large" className="w-full mb-4" onClick={handleResetPassword} disabled={!password || !confirmPassword}>
        Save New Password
      </Button>
    </div>
  </div>);
}